/** Format integer minor-unit strings without passing monetary values through Number. */
export function formatMinorAmount(amount: string, currency: string): string {
  if (!/^-?\d+$/.test(amount) || !/^[A-Z]{3}$/.test(currency)) {
    return `${currency} ${amount}`;
  }

  let fractionDigits: number;
  try {
    fractionDigits = new Intl.NumberFormat(undefined, { style: 'currency', currency })
      .resolvedOptions().maximumFractionDigits ?? 2;
  } catch {
    return `${currency} ${amount}`;
  }

  const minor = BigInt(amount);
  const negative = minor < 0n;
  const absolute = negative ? -minor : minor;
  const divisor = 10n ** BigInt(fractionDigits);
  const whole = absolute / divisor;
  const remainder = absolute % divisor;
  const groupedWhole = new Intl.NumberFormat(undefined, {
    useGrouping: true,
    maximumFractionDigits: 0,
  }).format(whole);
  const fraction = fractionDigits === 0
    ? ''
    : `.${remainder.toString().padStart(fractionDigits, '0')}`;

  return `${currency} ${negative ? '-' : ''}${groupedWhole}${fraction}`;
}

/** Catalog prices are already major-unit decimal strings; preserve them verbatim. */
export function formatDecimalPrice(price?: string | null, currency?: string | null): string {
  if (price === null || price === undefined || price === '') return '—';
  return currency ? `${currency} ${price}` : price;
}
